var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-item-li"},[_c('a',{staticClass:"menu-item-link",attrs:{"href":_vm.menudata.link},on:{"click":function($event){return _vm.sendClose()}}},[_vm._v(_vm._s(_vm.menudata.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }